<template>
  <Modal
    :title="$t('complete-content-modal.title')"
    :description="$t('complete-content-modal.description')"
    :confirm-label="$t('complete-content-modal.yes-complete')"
    @confirm="handleCompleteContent"
  >
    <template #activator>
      <Button
        :label="$t('launch-content-navigation-banner.mark-as-completed')"
        :color="ButtonColor.SUCCESS"
        class="whitespace-nowrap w-full md:w-fit"
      />
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Button, ButtonColor, Modal } from '@exfluential/ui';
import { ContentDto } from '~/api/contents';
import { useLoader } from '~/composables/use-loader';
import { createContentLaunchMetric, LaunchMetricType } from '~/api/metrics';

type Props = {
  content: ContentDto;
  hubSlug: string;
};

const props = defineProps<Props>();

const emit = defineEmits<{
  complete: [];
}>();

const handleCompleteContent = async () => {
  await useLoader({
    async action() {
      await createContentLaunchMetric(
        props.hubSlug,
        props.content.slug,
        LaunchMetricType.COMPLETED,
      );
      emit('complete');
    },
  });
};
</script>
